import React from 'react';

import MyRouter from './components/Router';

const App = () => {
  return <MyRouter />;
};

export default App;
